// Interface logic ported from RSG to load skills from JSON data.

function convertJsonSkillToSkill(jsonSkill, elementGroup, event, defaultCodePrefix) {
  const code = jsonSkill.code || `${defaultCodePrefix}-${elementGroup.replace(' ', '')}-${Math.random().toString(36).substr(2, 9)}`;
  const isGroupIElement = elementGroup === 'EG I';

  return {
    name: jsonSkill.name,
    code,
    value: jsonSkill.value,
    group: elementGroup,
    cvEligible: false,
    stickBonusEligible: false,
    juniorAllowed: true,
    groupIElement: isGroupIElement,
    apparatus: event,
    active: true
  };
}

export function loadSkillsFromJsonByGroup(jsonData, event, codePrefix) {
  const skills = [];

  for (const [elementGroup, data] of Object.entries(jsonData)) {
    if (elementGroup.startsWith('_')) continue;
    if (!Array.isArray(data)) continue;

    const validElementGroup = elementGroup;

    for (const jsonSkill of data) {
      const skill = convertJsonSkillToSkill(jsonSkill, validElementGroup, event, codePrefix);
      skills.push(skill);
    }
  }

  return skills;
}

export function loadJuniorASkillsFromJson(jsonData) {
  const result = {
    FX: [],
    PH: [],
    SR: [],
    VT: [],
    PB: [],
    HB: [],
    PL: []
  };

  const eventMap = {
    'Floor Exercise': 'FX',
    'Pommel Horse': 'PH',
    'Still Rings': 'SR',
    'Vault': 'VT',
    'Parallel Bars': 'PB',
    'Horizontal Bar': 'HB'
  };

  for (const [jsonEventName, data] of Object.entries(jsonData)) {
    if (jsonEventName === '_metadata') continue;
    if (!Array.isArray(data)) continue;

    const event = eventMap[jsonEventName];
    if (!event) continue;

    for (const jsonSkill of data) {
      const skill = {
        name: jsonSkill.name,
        code: jsonSkill.code || `JA-${event}-${Math.random().toString(36).substr(2, 6)}`,
        value: jsonSkill.value,
        group: 'Junior A',
        cvEligible: false,
        stickBonusEligible: false,
        juniorAllowed: true,
        groupIElement: false,
        apparatus: event,
        active: true
      };
      result[event].push(skill);
    }
  }

  return result;
}

export function loadAllSkillsFromJson() {
  return {
    FX: [],
    PH: [],
    SR: [],
    VT: [],
    PB: [],
    HB: [],
    PL: []
  };
}

export function determineCvEligibility(skill) {
  const cvEligibleCodes = [
    'FX-EG2-4', 'FX-EG2-12', 'FX-EG2-13',
    'PH-EG1-1', 'PH-EG1-2'
  ];

  return cvEligibleCodes.includes(skill.code) || skill.value >= 0.3;
}

export function determineStickBonusEligibility(skill) {
  const isDismount = skill.name.toLowerCase().includes('dismount') ||
    skill.code.includes('DISMOUNT') ||
    (skill.group === 'EG IV' && skill.value >= 0.3);

  return isDismount;
}
